import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extrato-log',
  templateUrl: './extrato-log.component.html',
  styleUrls: ['./extrato-log.component.css']
})
export class ExtratoLogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
